import { SvgIconProps } from "@mui/material";
import BaseSvgIcon from "./BaseSvgIcon";

export const ResendIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21 12.1525C21 17.0389 16.9706 21 12 21C7.02944 21 3 17.0389 3 12.1525C3 7.26622 7 3.30508 12 3.30508C18 3.30508 21 8.22034 21 8.22034M21 8.22034L21 3M21 8.22034H16.3449"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseSvgIcon>
);

export const RecipientIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 18.433C3 16.4308 4.45485 14.7254 6.43204 14.4098L6.61013 14.3814C8.19336 14.1287 9.80664 14.1287 11.3899 14.3814L11.568 14.4098C13.5451 14.7254 15 16.4308 15 18.433C15 19.2984 14.2984 20 13.433 20H4.56697C3.70156 20 3 19.2984 3 18.433Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path d="M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z" stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M15 11C16.933 11 18.5 9.433 18.5 7.5C18.5 5.567 16.933 4 15 4M17.3899 20H19.433C20.2984 20 21 19.2984 21 18.433C21 16.4308 19.5451 14.7254 17.568 14.4098V14.4098C17.4494 14.3909 17.3293 14.3814 17.2093 14.3814C16.8895 14.3814 16.7902 14.3814 16.2412 14.3814"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </BaseSvgIcon>
);

export const AirtimeIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 17L12 17.0226" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path d="M13.25 7H10.75" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
    <path
      d="M19.3003 14.087H4.69969M14.9161 20.6215C13.0047 21.1262 10.9953 21.1262 9.08393 20.6215C6.72938 19.9998 4.92802 18.1003 4.43096 15.7151L4.33598 15.2593C3.88801 13.1095 3.88801 10.8905 4.33598 8.74072L4.43096 8.28494C4.92801 5.89968 6.72938 4.0002 9.08394 3.3785C10.9953 2.87383 13.0047 2.87383 14.9161 3.3785C17.2706 4.00019 19.072 5.89968 19.569 8.28494L19.664 8.74072C20.112 10.8905 20.112 13.1095 19.664 15.2593L19.569 15.7151C19.072 18.1003 17.2706 19.9998 14.9161 20.6215Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </BaseSvgIcon>
);
export const RecipientsNavIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 18.433C3 16.4308 4.45485 14.7254 6.43204 14.4098L6.61013 14.3814C8.19336 14.1287 9.80664 14.1287 11.3899 14.3814L11.568 14.4098C13.5451 14.7254 15 16.4308 15 18.433C15 19.2984 14.2984 20 13.433 20H4.56697C3.70156 20 3 19.2984 3 18.433Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path d="M12.5 7.5C12.5 9.433 10.933 11 9 11C7.067 11 5.5 9.433 5.5 7.5C5.5 5.567 7.067 4 9 4C10.933 4 12.5 5.567 12.5 7.5Z" stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M15 11C16.933 11 18.5 9.433 18.5 7.5C18.5 5.567 16.933 4 15 4M17.3899 20H19.433C20.2984 20 21 19.2984 21 18.433C21 16.4308 19.5451 14.7254 17.568 14.4098V14.4098C17.4494 14.3909 17.3293 14.3814 17.2093 14.3814C16.8895 14.3814 16.7902 14.3814 16.2412 14.3814"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </BaseSvgIcon>
);
export const NavCheckListIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.07008 3V5.51375M15.9299 3V5.51375M3.83327 15.2485C3.38891 13.3097 3.38891 11.292 3.83327 9.35323C4.44858 6.66865 6.49673 4.57251 9.11985 3.94279C11.0142 3.48802 12.9858 3.48802 14.8801 3.94279C17.5033 4.57251 19.5514 6.66865 20.1667 9.35323C20.6111 11.292 20.6111 13.3097 20.1667 15.2485C19.5514 17.9331 17.5033 20.0292 14.8801 20.6589C12.9858 21.1137 11.0142 21.1137 9.11986 20.6589C6.49673 20.0292 4.44858 17.9331 3.83327 15.2485Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path d="M7.5 10.8571L8.5 11.7143L10.5 10M7.5 15.1429L8.5 16L10.5 14.2857M13 11.2857H16.5M13 15.5714H16.5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
  </BaseSvgIcon>
);

export const LightModeIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C12.3978 0 12.7794 0.158035 13.0607 0.43934C13.342 0.720644 13.5 1.10218 13.5 1.5V3C13.5 3.39782 13.342 3.77936 13.0607 4.06066C12.7794 4.34196 12.3978 4.5 12 4.5C11.6022 4.5 11.2206 4.34196 10.9393 4.06066C10.658 3.77936 10.5 3.39782 10.5 3V1.5C10.5 1.10218 10.658 0.720644 10.9393 0.43934C11.2206 0.158035 11.6022 0 12 0ZM18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12ZM17.304 19.425L18.3645 20.4855C18.6474 20.7587 19.0263 20.9099 19.4196 20.9065C19.8129 20.9031 20.1891 20.7453 20.4672 20.4672C20.7453 20.1891 20.9031 19.8129 20.9065 19.4196C20.9099 19.0263 20.7587 18.6474 20.4855 18.3645L19.425 17.304C19.1421 17.0308 18.7632 16.8796 18.3699 16.883C17.9766 16.8864 17.6004 17.0442 17.3223 17.3223C17.0442 17.6004 16.8864 17.9766 16.883 18.3699C16.8796 18.7632 17.0308 19.1421 17.304 19.425ZM20.484 3.5145C20.7652 3.79579 20.9232 4.17725 20.9232 4.575C20.9232 4.97275 20.7652 5.35421 20.484 5.6355L19.425 6.696C19.2866 6.83927 19.1211 6.95354 18.9381 7.03215C18.7551 7.11077 18.5583 7.15214 18.3591 7.15388C18.1599 7.15561 17.9624 7.11765 17.7781 7.04223C17.5937 6.96681 17.4262 6.85543 17.2854 6.71459C17.1446 6.57375 17.0332 6.40628 16.9578 6.22193C16.8823 6.03759 16.8444 5.84007 16.8461 5.6409C16.8479 5.44173 16.8892 5.2449 16.9678 5.06189C17.0465 4.87889 17.1607 4.71337 17.304 4.575L18.3645 3.5145C18.6458 3.23329 19.0273 3.07532 19.425 3.07532C19.8227 3.07532 20.2042 3.23329 20.4855 3.5145H20.484ZM22.5 13.5C22.8978 13.5 23.2794 13.342 23.5607 13.0607C23.842 12.7794 24 12.3978 24 12C24 11.6022 23.842 11.2206 23.5607 10.9393C23.2794 10.658 22.8978 10.5 22.5 10.5H21C20.6022 10.5 20.2206 10.658 19.9393 10.9393C19.658 11.2206 19.5 11.6022 19.5 12C19.5 12.3978 19.658 12.7794 19.9393 13.0607C20.2206 13.342 20.6022 13.5 21 13.5H22.5ZM12 19.5C12.3978 19.5 12.7794 19.658 13.0607 19.9393C13.342 20.2206 13.5 20.6022 13.5 21V22.5C13.5 22.8978 13.342 23.2794 13.0607 23.5607C12.7794 23.842 12.3978 24 12 24C11.6022 24 11.2206 23.842 10.9393 23.5607C10.658 23.2794 10.5 22.8978 10.5 22.5V21C10.5 20.6022 10.658 20.2206 10.9393 19.9393C11.2206 19.658 11.6022 19.5 12 19.5ZM4.575 6.696C4.71427 6.83537 4.87962 6.94594 5.06162 7.0214C5.24362 7.09686 5.4387 7.13573 5.63572 7.1358C5.83274 7.13587 6.02785 7.09714 6.2099 7.0218C6.39195 6.94647 6.55738 6.83602 6.69675 6.69675C6.83612 6.55748 6.94669 6.39213 7.02215 6.21013C7.09761 6.02813 7.13648 5.83305 7.13655 5.63603C7.13662 5.43901 7.09789 5.2439 7.02255 5.06185C6.94722 4.8798 6.83677 4.71437 6.6975 4.575L5.6355 3.5145C5.3526 3.24126 4.97369 3.09007 4.5804 3.09349C4.1871 3.09691 3.81088 3.25466 3.53277 3.53277C3.25466 3.81088 3.09691 4.1871 3.09349 4.5804C3.09007 4.97369 3.24126 5.3526 3.5145 5.6355L4.575 6.696ZM6.696 19.425L5.6355 20.4855C5.3526 20.7587 4.97369 20.9099 4.5804 20.9065C4.1871 20.9031 3.81088 20.7453 3.53277 20.4672C3.25466 20.1891 3.09691 19.8129 3.09349 19.4196C3.09007 19.0263 3.24126 18.6474 3.5145 18.3645L4.575 17.304C4.8579 17.0308 5.23681 16.8796 5.6301 16.883C6.0234 16.8864 6.39962 17.0442 6.67773 17.3223C6.95584 17.6004 7.11359 17.9766 7.11701 18.3699C7.12043 18.7632 6.96924 19.1421 6.696 19.425ZM3 13.5C3.39782 13.5 3.77936 13.342 4.06066 13.0607C4.34196 12.7794 4.5 12.3978 4.5 12C4.5 11.6022 4.34196 11.2206 4.06066 10.9393C3.77936 10.658 3.39782 10.5 3 10.5H1.5C1.10218 10.5 0.720644 10.658 0.43934 10.9393C0.158035 11.2206 0 11.6022 0 12C0 12.3978 0.158035 12.7794 0.43934 13.0607C0.720644 13.342 1.10218 13.5 1.5 13.5H3Z"
      fill="currentColor"
    />
  </BaseSvgIcon>
);
export const LogoutIcon = (props) => (
  <BaseSvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.319 22H6.433C3.989 22 2 20.011 2 17.565V6.436C2 3.99 3.989 2 6.433 2H11.308C13.754 2 15.744 3.99 15.744 6.436V7.368C15.744 7.782 15.408 8.118 14.994 8.118C14.58 8.118 14.244 7.782 14.244 7.368V6.436C14.244 4.816 12.927 3.5 11.308 3.5H6.433C4.816 3.5 3.5 4.816 3.5 6.436V17.565C3.5 19.184 4.816 20.5 6.433 20.5H11.319C12.931 20.5 14.244 19.188 14.244 17.576V16.633C14.244 16.219 14.58 15.883 14.994 15.883C15.408 15.883 15.744 16.219 15.744 16.633V17.576C15.744 20.016 13.758 22 11.319 22Z"
      fill="currentColor"
    />
    <mask
      id="mask0_522_17796"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={8}
      y={11}
      width={15}
      height={2}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M8.99609 11.25H22.537V12.75H8.99609V11.25Z" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_522_17796)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7871 12.75H9.74609C9.33209 12.75 8.99609 12.414 8.99609 12C8.99609 11.586 9.33209 11.25 9.74609 11.25H21.7871C22.2011 11.25 22.5371 11.586 22.5371 12C22.5371 12.414 22.2011 12.75 21.7871 12.75Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_522_17796"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={18}
      y={8}
      width={5}
      height={8}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M18.1094 8.33521H22.5367V15.666H18.1094V8.33521Z" fill="currentColor" />
    </mask>
    <g mask="url(#mask1_522_17796)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8591 15.666C18.6671 15.666 18.4741 15.593 18.3281 15.445C18.0361 15.151 18.0371 14.677 18.3301 14.385L20.7241 12L18.3301 9.61596C18.0371 9.32396 18.0351 8.84996 18.3281 8.55596C18.6201 8.26196 19.0941 8.26196 19.3881 8.55396L22.3161 11.469C22.4581 11.609 22.5371 11.801 22.5371 12C22.5371 12.199 22.4581 12.391 22.3161 12.531L19.3881 15.447C19.2421 15.593 19.0501 15.666 18.8591 15.666Z"
        fill="currentColor"
      />
    </g>
  </BaseSvgIcon>
);
export const SelectArrowDownIcon = (props: SvgIconProps) => (
  <BaseSvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_234_35868)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25994 11.9927C7.95054 12.1192 7.58492 11.7937 7.46378 11.3287C6.5551 7.84072 4.18105 5.74946 1.74691 6.29278C1.42241 6.36521 1.05482 6.04487 0.971916 5.57281C0.909602 5.21798 1.03175 4.89118 1.27094 4.81826C4.39861 3.86464 7.51617 6.61085 8.53872 11.2203C8.61692 11.5728 8.4925 11.8976 8.25994 11.9927Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74006 11.9927C8.04946 12.1192 8.41508 11.7937 8.53622 11.3287C9.4449 7.84072 11.8189 5.74946 14.2531 6.29278C14.5776 6.36521 14.9452 6.04487 15.0281 5.57281C15.0904 5.21798 14.9682 4.89118 14.7291 4.81826C11.6014 3.86464 8.48383 6.61085 7.46128 11.2203C7.38308 11.5728 7.5075 11.8976 7.74006 11.9927Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_234_35868">
        <rect width={15} height={15} fill="currentColor" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </BaseSvgIcon>
);
